var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("In Theatres")]),_c('ul',_vm._l((_vm.movies),function(movie,index){return _c('li',{key:index},[_c('Movie',{attrs:{"movie":movie}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }